import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary'

// Redirige si el dispositivo no es un iPad (incluye iPadOS moderno con user agent de escritorio)
(() => {
  try {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
    const ua = navigator.userAgent || '';
    const isIPadUA = /\biPad\b/.test(ua);
    const isIPadModern = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isIPad = isIPadUA || isIPadModern;
    if (!isIPad) {
    //  window.location.replace('https://franciscasweb.boostyourmenu.com/7110eda2a135111a5e4a390b0a572ac0d461hgf');
    }
  } catch (_e) {
    // Si la detección falla por alguna razón, no bloqueamos el render.
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
